import { FC } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

function withRouter(Component: any): FC<any> {
  return function WithRouter(props): JSX.Element {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const searchParams = useSearchParams();

    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
        searchParams={searchParams}
      />
    );
  };
}

export default withRouter;
